import type { BulkResponse, BulkResultItem } from '@nucleus-commerce/api-client/admin';

export interface MemberAddOutcome {
  added: number;
  /** Already in the pool: the add answered 200 and changed nothing. */
  unchanged: number;
  failed: number;
}

/** An add answers 200 for a new member too; one already in the pool carries `meta.unchanged`. */
export const isUnchanged = (item: BulkResultItem) =>
  item.status < 300 && item.meta?.unchanged === true;

export function memberAddOutcome(response: BulkResponse): MemberAddOutcome {
  const unchanged = response.items.filter(isUnchanged).length;
  return {
    added: Math.max(0, response.succeeded - unchanged),
    unchanged,
    failed: response.failed,
  };
}

/**
 * Rows a bulk `remove` excluded instead (`meta.excluded`): rule-matched members, which the next
 * rule refresh would add straight back.
 */
export function excludedInstead(response: BulkResponse): number {
  return response.items.filter((item) => item.status < 300 && item.meta?.excluded === true).length;
}
